import React, { FormEvent, useContext, useRef } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import { Alert, Box, Card, CardContent, CircularProgress, createStyles, Theme } from '@mui/material';
import { useMutation } from '@apollo/client';
import { GQL_LOGIN } from '../../graphql/mutations/auth';
import { AuthenticationContext } from '../../components/AuthenticationContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  }),
);

export default function Login({ onLogin }: { onLogin?: () => void }) {
  const { saveToken } = useContext(AuthenticationContext);
  const email = useRef<HTMLInputElement>(null);
  const password = useRef<HTMLInputElement>(null);

  const [login, { loading, error }] = useMutation(GQL_LOGIN, {
    onError(err) {
      console.error(err);
    },
    onCompleted(data) {
      saveToken(data.login.token);
      if (onLogin) onLogin();
    },
  });
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const variables = {
      loginData: {
        email: email?.current?.value || '',
        password: password?.current?.value || '',
      },
    };
    login({ variables });
  };

  //!*Ar7070
  const classes: any = useStyles();

  if (loading)
    return (
      <Box display="flex" minHeight="300px" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );

  return (
    <Container maxWidth="xs">
      <Card>
        <CardContent>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>

            {error && <Alert severity="error">ERROR: {error?.message}</Alert>}

            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                inputRef={email}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                inputRef={password}
              />
              <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                Sign In
              </Button>
            </form>
          </div>
        </CardContent>
      </Card>
    </Container>
  );
}
